<template>
	<div class="d-flex justify-content-center">
		<div class="card card-profile w-100" >
			<div class="card-header">Profil</div>
			<div class="card-body">
                <Loading v-if="!profile" class="my-5 w-100"/>
				<div v-if="profile" class="profile-wrapper">
					<div class="row" v-if="profile.person.titleSuffix || profile.person.titlePrefix">
						<div class="col-4">Titul:</div>
						<div class="col-8">{{ profile.person.titlePrefix }} {{ profile.person.titleSuffix }}</div>
					</div>
					<div class="row">
						<div class="col-4">Meno:</div>
						<div class="col-8">{{ profile.person.firstName }}</div>
					</div>
					<div class="row">
						<div class="col-4">Priezvisko:</div>
						<div class="col-8">{{ profile.person.lastName }}</div>
					</div>
					<div class="row" v-if="profile.idNumber">
						<div class="col-4">Číslo preukazu totožnosti:</div>
						<div class="col-8">{{ profile.idNumber }}</div>
					</div>

					<div class="row mt-5">
						<div class="col-4"><strong>Trvalé bydlisko</strong></div>
					</div>
					<div class="row">
						<div class="col-4">Ulica</div>
						<div class="col-8">{{ profile.person.street }}</div>
					</div>
					<div class="row">
						<div class="col-4">Mesto</div>
						<div class="col-8">{{ profile.person.city }}</div>
					</div>
					<div class="row">
						<div class="col-4">PSČ</div>
						<div class="col-8">{{ profile.person.zip }}</div>
					</div>

					<div class="row mt-5">
						<div class="col-4">
							<strong>Korešpondenčná<br />adresa</strong>
						</div>
						<div class="col-3"></div>
						<div class="col-5">
							<label class="address-checkbox">
								<input v-model="profile.useContactAddress" type="checkbox" class="mr-2"
                                       @click="confirmEdit('useContactAddress', null, !profile.useContactAddress)"/>
								<strong>iná ako adresa trvalého bydliska</strong>
							</label>
						</div>
					</div>
					<template v-if="profile.useContactAddress">
						<div class="row">
							<div class="col-4 col-md-4">Ulica</div>
							<div class="col-6 col-md-3" v-if="editedField !== 'street'">{{ profile.contactPerson.street }}</div>
							<div class="col-6 col-md-3 pl-0 pl-md-3" v-if="editedField === 'street'">
								<input type="text" v-model="profile.contactPerson.street" />
							</div>
							<div class="col-1 col-md-5">
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="edit('street', profile.contactPerson.street)"
                                    :disabled="editedField && editedField !== 'street'"
									v-if="editedField !== 'street'"
								>
									<font-awesome-icon icon="pen" />
								</button>
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="confirmEdit('contactAddress', 'street', profile.contactPerson.street)"
									v-if="editedField === 'street'"
								>
									<font-awesome-icon icon="check" />
								</button>
							</div>
						</div>
						<div class="row">
							<div class="col-4 col-md-4">Mesto</div>
							<div class="col-6 col-md-3" v-if="editedField !== 'city'">{{ profile.contactPerson.city }}</div>
							<div class="col-6 col-md-3 pl-0 pl-md-3" v-if="editedField === 'city'">
								<input type="text" v-model="profile.contactPerson.city" />
							</div>
							<div class="col-1 col-md-5">
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="edit('city', profile.contactPerson.city)"
                                    :disabled="editedField && editedField !== 'city'"
									v-if="editedField !== 'city'"
								>
									<font-awesome-icon icon="pen" />
								</button>
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="confirmEdit('contactAddress', 'city', profile.contactPerson.city)"
									v-if="editedField === 'city'"
								>
									<font-awesome-icon icon="check" />
								</button>
							</div>
						</div>
						<div class="row mb-5">
							<div class="col-4 col-md-4">PSČ</div>
							<div class="col-6 col-md-3" v-if="editedField !== 'zip'">{{ profile.contactPerson.zip }}</div>
							<div class="col-6 col-md-3 pl-0 pl-md-3" v-if="editedField === 'zip'">
								<input type="text" v-model="profile.contactPerson.zip" />
							</div>
							<div class="col-1 col-md-5">
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="edit('zip', profile.contactPerson.zip)"
                                    :disabled="editedField && editedField !== 'zip'"
									v-if="editedField !== 'zip'"
								>
									<font-awesome-icon icon="pen" />
								</button>
								<button
									type="button"
									class="btn btn-edit p-0 btn-sm btn-link"
									@click="confirmEdit('contactAddress', 'zip', profile.contactPerson.zip)"
									v-if="editedField === 'zip'"
								>
									<font-awesome-icon icon="check" />
								</button>
							</div>
						</div>
					</template>
                    <div class="row">
                        <div class="col-4">
                            <strong>Kontaktné údaje</strong>
                        </div>
                    </div>
					<div class="row">
						<div class="col-4 col-md-4">E-mail</div>
						<div class="col-6 col-md-3" v-if="editedField !== 'email'">{{ profile.email }}</div>
						<div class="col-6 col-md-3 pl-0 pl-md-3" v-if="editedField === 'email'">
                            <input type="email" v-model="profile.email" />
                        </div>
						<div class="col-1 col-md-5">
							<button
								type="button"
								class="btn btn-edit p-0 btn-sm btn-link"
								@click="edit('email', profile.email)"
                                :disabled="editedField && editedField !== 'email'"
								v-if="editedField !== 'email'"
							>
								<font-awesome-icon icon="pen" />
							</button>
							<button
								type="button"
								class="btn btn-edit p-0 btn-sm btn-link"
								@click="confirmEdit('contactInfo', 'email', profile.email)"
								v-if="editedField === 'email'"
							>
								<font-awesome-icon icon="check" />
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-4 col-md-4">Mobil</div>
						<div class="col-6 col-md-3" v-if="editedField !== 'mobilePhone'">{{ profile.mobilePhone }}</div>
						<div class="col-6 col-md-3 pl-0 pl-md-3" v-if="editedField === 'mobilePhone'">
							<input type="text" v-model="profile.mobilePhone" />
						</div>
						<div class="col-1 col-md-5">
							<button
								type="button"
								class="btn btn-edit p-0 btn-sm btn-link"
								@click="edit('mobilePhone', profile.mobilePhone)"
                                :disabled="editedField && editedField !== 'mobilePhone'"
								v-if="editedField !== 'mobilePhone'"
							>
								<font-awesome-icon icon="pen" />
							</button>
							<button
								type="button"
								class="btn btn-edit p-0 btn-sm btn-link"
								@click="confirmEdit('contactInfo', 'mobilePhone', profile.mobilePhone)"
								v-if="editedField === 'mobilePhone'"
							>
								<font-awesome-icon icon="check" />
							</button>
						</div>
					</div>

					<div class="row mt-5">
						<div class="col-12 col-lg-11">
                            <button type="button" class="btn btn-primary mr-0 mb-2 mr-md-3" :disabled="editedField || (!changedContactInfo && !changedUseContactAddress)" @click="updateProfile">
                                <span class="ml-2 mr-2">Aktualizovať údaje</span>
                            </button>
							<button type="button" class="btn btn-primary mb-2" @click="openedChangePasswordModal = true">
								<span class="ml-2 mr-2">Zmeniť heslo</span>
							</button>
						</div>
					</div>

					<div class="row mt-5 " v-if="assignedToSomeone.length">
						<div class="col-4">
							<strong>Spriaznené<br />účty</strong>
						</div>
						<div class="col-8">
                            <div class="portfolio-buttons">
                                <button type="button"
                                        class="btn"
                                        disabled
                                        v-for="item in assignedToSomeone">
                                    {{ item.fullName }}
                                </button>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal title="Zmena hesla" v-model="openedChangePasswordModal" hide-footer>
			<change-password @changed="openedChangePasswordModal = false" />
		</b-modal>
	</div>
</template>

<script>
import PortfolioButtons from "../../../components/PortfolioButtons";
import ChangePassword from "../../../components/form/ChangePassword";
import Loading from "../../../components/Loading";

export default {
	name: "Profile",
	components: {
		ChangePassword,
		PortfolioButtons,
        Loading
	},
    mounted() {
        this.$store.dispatch('account/getProfileInfo');
        this.$store.dispatch('account/assignedToSomeone');
    },
    computed: {
        loading() {
            return this.$store.state.account.loading;
        },
		profile() {
			return this.$store.state.account.profileInfo;
		},
        assignedToSomeone() {
            return this.$store.state.account.assignedToSomeone;
        },
	},
	methods: {
		edit(field, value) {
			this.editedField = field;
            this.editedValue = value;
		},
		confirmEdit(type, name, value) {
            if (type === 'useContactAddress') {
                this.changes[type]['changed'] = !this.changes[type]['changed'];
                this.changes[type]['value'] = value;
                this.changedUseContactAddress = !this.changedUseContactAddress;
            } else if (value !== this.editedValue) {
                this.changes[type][name]['value'] = value;
                this.changes[type][name]['changed'] = true;
                this.changedContactInfo = true;
            }
            this.editedField = null;
		},
        updateProfile() {
            this.$store.dispatch("account/updateProfile", {
                data: this.profile,
                changes: this.changes
            }).then(() => {
                this.profile = this.$store.state.account.profile?.profile;
            });
        }
	},
	data() {
		return {
			editedField: null,
            editedValues: null,
			openedChangePasswordModal: false,
            changedContactInfo: false,
            changedUseContactAddress: false,
            changes: {
                useContactAddress: {
                    value: '',
                    changed: false
                },
                contactAddress: {
                    street: {
                        value: '',
                        name: 'Ulica',
                        changed: false
                    },
                    city: {
                        value: '',
                        name: 'Mesto',
                        changed: false
                    },
                    zip: {
                        value: '',
                        name: 'PSČ',
                        changed: false
                    }
                },
                contactInfo: {
                    email: {
                        value: '',
                        name: 'E-mail',
                        changed: false
                    },
                    mobilePhone: {
                        value: '',
                        name: 'Mobil',
                        changed: false
                    }
                }
            }
		};
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.card-profile {
	max-width: 800px;

	.btn-edit {
		font-size: 12px;
		line-height: 12px;
	}

	.address-checkbox {
		font-size: 13px;
	}

	.profile-wrapper {
		font-size: 13px;

		> .row {
			margin-top: 15px;

			> div:first-child {
				text-align: right;
				color: #9a9a9a;

				strong {
					color: #fff;
				}
			}
		}
	}

    @include media-breakpoint-down(md) {
        .card-body {
            padding-left: 10px;
            padding-right: 10px;
        }
    }
}
</style>
